export default {
  title: 'Prospects',
  noQuoteRequests: 'No quote requests',
  noContacts: 'No contacts',
  showRequest: 'Show request',
  labels: {
    projectName: 'Project name',
  },
  quoteRequestRespondModal: {
    acceptTitle: 'Accept a quote request.',
    declineTitle: 'Reject a quote request.',
    clientName: 'From',
    projectType: 'Project type',
    responsible: 'Responsible',
    acceptButton: 'Use 1 token and accept',
    showNewContact: 'Show my new contact',
    startQuote: 'Start my quote',
    creditNote: '1 request = 1 token',
    declineButton: 'Reject',
    requestMessageLabel: 'Message',
    continueQuote: 'Continue my quote',
    acceptedTitle: 'Submission request accepted',
    declinedTitle: 'Submission request declined',
    acceptingButton: 'Accepting...',
    acceptedMessage:
      'You can now submit your quote to {{requesterName}} from the <bold>Submission project creator.</bold>',
    jobNotAvailable: 'This project is no longer available. You can no longer accept this request.',
    acceptError:
      'An unknown error occurred while accepting the request. Please try again or contact support.',
    decliningButton: 'Declining...',
    declineReasonLabel: 'Message for <bold>{{freelancerName}}</bold>',
    declineMessageDescription:
      'To decline the submission request from <bold>{{ requesterName }}</bold>, you must provide a brief explanation.',
    declineMessagePlaceholder: 'Write a brief explanation to decline the request',
    declineSuccess:
      'You declined the request from <bold>{{ requesterName}}</bold>. A notification will be sent with your message.',
    declineError:
      'An unknown error occurred while declining the request. Please try again or contact support.',
    manageQuotes: 'Manage my submissions',
    insufficientCredits: 'Insufficient credits',
    insufficientCreditsNote: 'You need credits to respond to this request.',
  },
  quoteRequestList: {
    allianceQuoteRequestMessage: 'You are invited to submit a quote for this project.',
    quoteRequestMessage: 'You are invited to submit a quote for this project.',
  },
  contacts_title: 'My contacts',
} as const;
